import React from 'react';

import FetchState, { shouldFetch } from '../../utils/FetchState';

export interface Props {
  onFetchDataActions: ((fetchState: FetchState | undefined) => void)[];
  fetchStates: (FetchState | undefined)[];
  children?: React.ReactNode;
  render?: (props: { fetchStates: (FetchState | undefined)[] }) => JSX.Element;
}

function Fetch(props: Props) {
  const { fetchStates, onFetchDataActions, children, render } = props;

  React.useEffect(() => {
    fetchStates.forEach((fetchState, index) => {
      if (shouldFetch(fetchState)) {
        onFetchDataActions[index](fetchState);
      }
    });
  }, [fetchStates, onFetchDataActions]);

  if (render && children) {
    throw new Error('Both children and render props is specified!');
  }

  if (render) {
    return render({ fetchStates });
  }

  return <>{children}</>;
}

export default Fetch;
